import { jsx as _jsx } from "react/jsx-runtime";
// Homepage entry point - Mounts HomePage component to WordPress
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/globals.css';
// Import Homepage component
import { Homepage } from '@/pages/Homepage';
// Mount function
function mountHomePage() {
    var _a, _b;
    const mountPoint = document.getElementById('homepage-root');
    if (!mountPoint) {
        console.warn('[React] Homepage mount point not found');
        return;
    }
    // Get WordPress data
    const wpData = window.wpData || {};
    // Navigation handler for WordPress
    const handleNavigate = (page, recipeSlug) => {
        // Handle recipe-detail navigation with slug
        if (page === 'recipe-detail' && recipeSlug) {
            window.location.href = `/recipes/${recipeSlug}/`;
            return;
        }
        const pageMap = {
            home: '/',
            catalog: '/categories',
            'design-system': '/design-system',
            login: '/login',
            menu: '/menu',
            'recipe-box': '/recipe-box',
            recipes: '/recipes',
            profile: '/profile',
            'shopping-list': '/shopping-list',
        };
        // For catalog, try multiple slugs in order of preference
        if (page === 'catalog') {
            const catalogSlugs = ['/catalog', '/categories', '/generic-catalog'];
            // Try the first slug (WordPress will handle 404 if it doesn't exist)
            window.location.href = catalogSlugs[0];
            return;
        }
        const url = pageMap[page] || '/';
        window.location.href = url;
    };
    // Create root and render
    const root = ReactDOM.createRoot(mountPoint);
    root.render(_jsx(React.StrictMode, { children: _jsx(Homepage, { onNavigate: handleNavigate, menuItems: ((_a = wpData.menus) === null || _a === void 0 ? void 0 : _a.primary) || [], footerMenuItems: ((_b = wpData.menus) === null || _b === void 0 ? void 0 : _b.footer) || [], siteName: wpData.siteName }) }));
}
// Auto-mount when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHomePage);
}
else {
    mountHomePage();
}
// Export for manual mounting if needed
export { mountHomePage };
